interface IProps {
    color?: string;
    className?: string;
}

export const IconBack = (props: IProps) => {
    const { color = "#BC9067", className = "" } = props;

    return (
        <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd"
                d="M9.54551 0.454507C9.98479 0.893849 9.98479 1.60615 9.54551 2.0455L2.84096 8.75L9.54551 15.4545C9.98479 15.8938 9.98479 16.6062 9.54551 17.0455C9.10616 17.4848 8.39381 17.4848 7.95446 17.0455L0.454464 9.54553C0.0151878 9.10618 0.0151879 8.39383 0.454464 7.95448L7.95446 0.454507C8.39381 0.0151643 9.10616 0.0151644 9.54551 0.454507Z"
                fill={color} />
        </svg>


    );
};
